import { NcButton, NcModal } from "@noted/noted-components";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { SessionTimeoutStates } from "~/components/auth-timeout/auth-timeout-handler";
import { useI18n } from "~/hooks/use-i18n";

type AuthTimeoutModalProps = {
  state: SessionTimeoutStates;
  renewSessionTime: () => void;
};

export function AuthTimeoutModal({ state, renewSessionTime }: AuthTimeoutModalProps) {
  const { t } = useI18n();
  const navigate = useNavigate();

  useEffect(() => {
    if (state === "EXPIRED") {
      navigate("/logout");
    }
  }, [state]);

  if (state === "NONE" || state === "EXPIRED") return null;

  const handleLogout = () => navigate("/logout");

  return (
    <NcModal onOpenChange={handleLogout} isOpen={true} className="max-w-[30rem]">
      <NcModal.Header className="text-center">
        <NcModal.Heading>{t("timeoutWarning.expiring.heading")}</NcModal.Heading>
      </NcModal.Header>
      <NcModal.Body className="grid gap-2 p-5 text-center">
        <IconExpiring />
        <p className="text-xl">{t("timeoutWarning.expiring.state")}</p>
        <p>{t("timeoutWarning.expiring.action.description")}</p>
      </NcModal.Body>
      <NcModal.Footer className="justify-center">
        <NcButton className="w-40" onPress={handleLogout}>
          {t("timeoutWarning.expiring.action.end")}
        </NcButton>
        <NcButton className="w-40" variant="primary" onPress={renewSessionTime}>
          {t("timeoutWarning.expiring.action.continue")}
        </NcButton>
      </NcModal.Footer>
    </NcModal>
  );
}

const IconExpiring = () => (
  <svg width="74" height="98" viewBox="0 0 74 98" className="mx-auto my-2 block">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2C0 0.89543 0.895431 0 2 0H72C73.1046 0 74 0.895431 74 2V5C74 6.10457 73.1046 7 72 7H70.9473C70.1822 25.0816 61.1694 40.2842 48.7508 46.2707C48.2758 46.4997 47.7958 46.7152 47.3112 46.9168C46.8778 47.0971 46.4407 47.2663 46 47.4243V50.5757C46.4407 50.7337 46.8778 50.9029 47.3112 51.0832C47.7958 51.2848 48.2758 51.5003 48.7508 51.7293C61.1694 57.7158 70.1822 72.9184 70.9473 91H72C73.1046 91 74 91.8954 74 93V96C74 97.1046 73.1046 98 72 98H2C0.89543 98 0 97.1046 0 96V93C0 91.8954 0.895431 91 2 91H3.05275C3.85332 72.0791 13.685 56.3107 27 50.9559V47.0441C13.685 41.6893 3.85332 25.9209 3.05275 7H2C0.89543 7 0 6.10457 0 5V2ZM65.9432 91H8.05691C8.85298 73.5879 17.9005 60.0046 28.8656 55.5948C30.7593 54.8332 32 52.997 32 50.9559V47.0441C32 45.003 30.7593 43.1668 28.8656 42.4052C17.9005 37.9954 8.85298 24.4121 8.05691 7H65.9432C65.1277 24.8648 55.6392 38.6587 44.3133 42.7174C42.3259 43.4295 41 45.3132 41 47.4243V50.5757C41 52.6868 42.3259 54.5705 44.3133 55.2826C55.6392 59.3413 65.1277 73.1352 65.9432 91Z"
      fill="#4E5864"
    />
    <path
      d="M22.6669 32C27.0092 36.7214 32.0686 39 37 39C41.9314 39 46.9908 36.7214 51.3331 32H22.6669Z"
      fill="#FFB366"
    />
    <circle cx="37" cy="44" r="2" fill="#FFB366" />
    <circle cx="37" cy="51" r="2" fill="#FFB366" />
    <circle cx="37" cy="58" r="2" fill="#FFB366" />
    <path
      d="M55.7281 83C54.4841 78.0514 52.4154 73.8032 49.9171 70.5334C45.7989 65.1434 41.1055 63 37 63C32.8945 63 28.2011 65.1434 24.0829 70.5334C21.5846 73.8032 19.5159 78.0514 18.2719 83H55.7281Z"
      fill="#FFB366"
    />
  </svg>
);
